// ACTIONS
const UPDATE_PROGRESS = 'client/utility/UPDATE_PROGRESS'

// ACTION CREATORS
export const updateProgress = progress => ({
  type: UPDATE_PROGRESS,
  payload: {
    progress,
  },
})

// REDUCERS
const initialState = {
  progress: 0,
}

const utilityReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
      }

    default:
      return state
  }
}

export default utilityReducer
